/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {View} from 'react-native';
import {get, noop} from 'lodash';

//HIDDEN: CONNAPP-579
//import Avatar from '/component/base/Avatar';
import Checkbox from '/component/base/Checkbox';
import Icon from '/component/base/Icon';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';

import {styles} from './PeopleListItem.style';

interface PeopleListItemProps {
  getTheme: (key: string) => string;
  style: Object;
  hasCheckbox: boolean;
  isChecked: boolean;
  label: string | React.ReactNode;
  currentCount: number;
  targetCount: number;
  peopleList: Array<{accountEmail: string; avatarUrl: string | null}>;
  isCoach: boolean;
  canExpand: boolean;
  expanded: boolean;
  onPress: () => void;
  readonly: boolean;
  oneLineLayout: boolean;
  testID: string;
}

const PeopleListItem: React.FC<PeopleListItemProps> = ({
  getTheme = noop,
  style: styleProp = {},
  hasCheckbox = false,
  isChecked = false,
  label = null,
  currentCount = 0,
  targetCount = 0,
  peopleList = [],
  isCoach = false,
  canExpand = true,
  expanded = true,
  onPress = noop,
  readonly = false,
  oneLineLayout = false,
  testID = undefined,
}) => {
  const caretIcon = expanded ? 'chevron-up' : 'chevron-down';
  const peopleData = [];

  for (let i = 0; i < targetCount; i++) {
    peopleData.push({
      number: i + 1,
      url: peopleList[i] ? peopleList[i].avatarUrl : null,
      email: peopleList[i] ? peopleList[i].accountEmail : null,
    });
  }

  const avatarWrapperStyle = [styles.avatarWrapper];
  if (oneLineLayout) {
    if (canExpand) {
      // @ts-expect-error TS(2345): Argument of type '{ marginRight: number; }' is not... Remove this comment to see the full error message
      avatarWrapperStyle.push(styles.avatarWrapperSpacingRight);
    }
  } else {
    // @ts-expect-error TS(2345): Argument of type '{ marginTop: number; }' is not a... Remove this comment to see the full error message
    avatarWrapperStyle.push(styles.avatarWrapperSpacingTop);
  }

  const iconStyle = {
    ...styles.icon,
    ...getTheme('competency.iconColor'),
  };

  const renderedAvatars = (
    <View style={avatarWrapperStyle}>
      {peopleData.map(({email, number, url}, index) => {
        const avatarStyle = [styles.avatar];
        if (oneLineLayout) {
          avatarStyle.push(styles.avatarSpacingLeft);
        } else {
          avatarStyle.push(styles.avatarSpacingRight);
        }

        return (
          <View key={index} style={avatarStyle}>
            {index < currentCount ? (
              /*<Avatar
                size={25}
                avatarUrl={url}
                avatarKey={email}
                isCoach={isCoach}
              /> */
              <Icon
                name="circle-checkmark-filled"
                style={iconStyle}
                accessible={false}
                accessibilityElementsHidden={true}
                importantForAccessibility="no-hide-descendants"
              />
            ) : (
              <View style={styles.avatarPlaceholder}>
                <Text
                  variant="subheading"
                  emphasis="low"
                  style={styles.placeholder}
                  accessible={false}
                  accessibilityElementsHidden={true}
                  importantForAccessibility="no-hide-descendants">
                  {number}
                </Text>
              </View>
            )}
          </View>
        );
      })}
    </View>
  );

  const listItemLabel = (
    <>
      <Text allowFontScaling maxFontSizeMultiplier={2} style={styles.label}>
        {currentCount}/{targetCount} {label}
      </Text>
      {!oneLineLayout && renderedAvatars}
    </>
  );

  const listItemSuffix = (
    <View style={styles.suffix}>
      {oneLineLayout && renderedAvatars}
      {canExpand && <Icon name={caretIcon} testID="caret-icon" />}
    </View>
  );

  const listItemStyle = {
    ...get(styleProp, 'listItem', {}),
  };

  return (
    <ListItem
      style={listItemStyle}
      label={listItemLabel}
      onPress={onPress}
      prefix={hasCheckbox && <Checkbox checked={isChecked} readonly />}
      readonly={readonly}
      suffix={listItemSuffix}
      testID={testID}
    />
  );
};

export default withHOC(withTheme, withCompetency)(PeopleListItem);
